import { render } from "./ResetPasswordSuccessPage.vue?vue&type=template&id=fd2b6de6&scoped=true"
import script from "./ResetPasswordSuccessPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordSuccessPage.vue?vue&type=script&lang=js"

import "./ResetPasswordSuccessPage.vue?vue&type=style&index=0&id=fd2b6de6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2b6de6"]])

export default __exports__